






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {EmailDestinatario} from '@/model/resource/EmailDestinatario'
import {InputEmailDestinatarioSchema} from '@/schema/resource/EmailDestinatario/InputEmailDestinatarioSchema'

@Component
export default class PersistEmailDestinatarioView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputEmailDestinatarioSchema()
  emailDestinatario = new EmailDestinatario()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.emailDestinatario.getEmailDestinatario(id)
    }

    $.await.done('getEmailDestinatario')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.emailDestinatario.persistEmailDestinatario()
    await Helper.successAndPush(
      'system.success.persist',
      '/email-destinatario/list'
    )
  }
}
